import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	findAll (query) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/event/members', {params: query}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/event/member.js